'use client';

import { getCurrentLocationAndLanguage } from '@utils/location';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import Link from 'next/link';
import { ArrowUpRight } from "lucide-react";
import Divider from "@components/other/divider";
import GoldIcon from "@components/Svg/gold-icon";
export default function AboutOurLeadership() {
  const {
    t
  } = useTranslation();
  const {
    location
  } = getCurrentLocationAndLanguage();
  if (['tr', 'ir', 'az', 'ge', 'uz'].includes(location)) return null;
  return <>
            <Divider icon={GoldIcon} data-sentry-element="Divider" data-sentry-source-file="our-leadership.tsx" />
            <div className="w-full my-8">
                <article className="max-w-4xl mx-auto p-4 border rounded-xl shadow-lg bg-white dark:bg-zinc-900">
                    <Link href="https://www.flpkgz.com/downloads/common/our-leadership-ru/index.html" target="_blank" data-sentry-element="Link" data-sentry-source-file="our-leadership.tsx">
                        <Image src="/assets/images/our-leadership-ru.jpg" alt="leadership" width={800} height={400} className="w-full h-auto rounded-2xl" data-sentry-element="Image" data-sentry-source-file="our-leadership.tsx" />
                    </Link>
                    <p className="text-neutral-600 dark:text-neutral-400 my-4">
                        {t('common:text-our-leadership-about')}
                    </p>
                    <a href="https://www.flpkgz.com/downloads/common/our-leadership-ru/index.html" target="_blank" rel="noopener noreferrer" className="inline-flex items-center mt-4 p-2 px-4 py-2 text-neutral-700 dark:text-neutral-100 bg-neutral-50 dark:bg-neutral-800 rounded-lg border border-neutral-200 dark:border-neutral-700 hover:bg-neutral-100 dark:hover:bg-neutral-700 hover:text-neutral-900 dark:hover:text-white transition-colors duration-200">
                        <span>{t('common:text-read-more')}</span>
                        <ArrowUpRight className="h-8 w-8 ml-2 transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1 border rounded-2xl p-1" data-sentry-element="ArrowUpRight" data-sentry-source-file="our-leadership.tsx" />
                    </a>
                </article>
            </div>
        </>;
}